import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import '@/styles/tailwind.css';
import { router } from '@/router';
import { useWalletStore } from '@/stores/wallet';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('root element missing');

// Restore the previously-connected Solana wallet on app boot so a page reload
// (or opening a new tab) doesn't drop the user back to "Connect your wallet".
// Deferred to the next tick so the wallet extension's content script has had
// a chance to inject by the time we call through to it. Failures are silent
// — the user can always click Connect Wallet.
setTimeout(() => {
  useWalletStore
    .getState()
    .tryAutoConnect()
    .catch(() => {
      /* swallowed — already logged inside the action */
    });
}, 0);

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
